// extracted by mini-css-extract-plugin
module.exports = {"tablet":"680px","laptop":"980px","desktop":"1180px","list":"page_list__nfhYs","listItem":"page_listItem__o59dW","grantCard":"page_grantCard__WtpuG"};